import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { DataService } from 'src/app/services/data.service';

import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cus-add-address',
  templateUrl: './cus-add-address.component.html',
  styleUrls: ['./cus-add-address.component.scss'],
})
export class CusAddAddressComponent implements OnInit {

  @Input() customer_id: any;
  @Input() customer_data: any;
  address_type: any;
  address_info: any = {};
  submitted = false;
  country_list: any = [];
  states_list: any = [];
  address_form:any = FormGroup;
  // @Input() is_modal;
  
  constructor(public db: DataService, public formBuilder: FormBuilder, public modalCtrl: ModalController) {
    this.get_country_list()
  }

  ngOnInit() {  
    console.log("customer_id", this.customer_id);

    if (this.address_type == "Add") {
      this.address_info.first_name = this.customer_id.first_name || "";
      this.address_info.last_name = this.customer_id.last_name || "";
      this.address_info.address = "";
      this.address_info.city = "";
      this.address_info.zipcode = "";
      this.address_info.state = 'Tamil Nadu';
      this.address_info.country = 'India'
    }
    this.address_form = this.formBuilder.group({
      first_name: new FormControl(
        this.address_info.first_name || "",
        Validators.required
      ),
      last_name: new FormControl(
        this.address_info.last_name || "",
        Validators.required
      ),
      address: new FormControl(
        this.address_info.address || "",
        Validators.required
      ),
      city: new FormControl(this.address_info.city || "", Validators.required),
      state: new FormControl(
        this.address_info.state || "",
        Validators.required
      ),
      country: new FormControl(
        this.address_info.country || "",
        Validators.required
      ),
      zipcode: new FormControl(
        (this.address_info.zipcode || ''),
        [Validators.required, Validators.pattern('[0-9]{6}')]),
    });
     if (this.country_list.length == 0 && this.address_info.country) {
      this.country_list = [{ name: this.address_info.country }];
      this.address_form.value.country = this.address_info.country;
    }
    if (this.states_list.length == 0 && this.address_info.state) {
      this.states_list = [{ name: this.address_info.state }];
      this.address_form.value.state = this.address_info.state;
    }
  }

  
  get validation(){
    return this.address_form.controls;
  }

  get_country_list() {
    console.log("li", this.address_info);
    this.db.domain_get_country_list().subscribe(
      (res: any) => {
        console.log("country", res.message);
        this.country_list = res.message;
        if (this.address_info.country) {
          this.address_form.value.country = this.address_info.country;
        }
        this.get_state_list();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  get_state_list() {
    this.db.domain_get_states_lists(this.address_info.country).subscribe(
      (r: any) => {
        this.states_list = r.message;
        if (this.address_info.state) {
          this.address_form.value.state = this.address_info.state;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  value_changed(evt) {
    if (evt.detail.value) {
      this.address_info.country = evt.detail.value;
      this.get_state_list();
    }
  }


  insert_address() {
    // console.log("Addres")
    this.submitted = true;
    if (this.address_form.valid) {
      // console.log("li", this.address_info);
      this.address_info = this.address_form.value;
      this.submitted = true;
      this.address_info.customer = this.customer_id.name;
      this.address_info.addr1 = this.address_form.value.address;
      this.address_info.pincode = this.address_info.zipcode;
      this.address_info.city = this.address_form.value.city;
      // console.log(this.address_info, "-------------")
      this.db.insert_address({ data: JSON.stringify(this.address_info) }, 1).subscribe((res: any) => {
        // console.log("insert", res);
        this.modalCtrl.dismiss();
        if (res.status == "failed") {
          this.db.alert(res.message)
        }
      });
    }
  }


  dismiss_modal() {
    this.modalCtrl.dismiss({ status: "closed" });
  }

  close(){
    this.modalCtrl.dismiss();
  }

  edit_address() {
    this.submitted = true;
    if (this.address_form.valid) {
    let dataArray = {
      name: this.address_info.name,
      address: this.address_form.value.address,
      city: this.address_form.value.city,
      first_name: this.address_form.value.first_name,
      state: this.address_form.value.state,
      last_name: this.address_form.value.last_name,
      zipcode: this.address_form.value.zipcode,
      pincode: this.address_form.value.zipcode,
      addr1: this.address_form.value.address,
      phone: this.customer_data.phone,
     customer: this.customer_data.name,
    };
    let datas = {
      data: JSON.stringify(dataArray),
    };
      if (this.address_form.valid) {
        this.db.update_address(datas, 1).subscribe((res: any) => {
          console.log("edit working", res);
          this.modalCtrl.dismiss();
        },
          (error) => {
            console.log(error);
          }
        );
      }
    }
  }
}